import React from 'react';
import { motion } from 'framer-motion';
import { stats } from '../data/content';
function Stats() {
  return (
    <section className="stats-band">
      <div className="wrap stats-grid">
        {stats.map((s, i) => (
          <motion.div className="stat" key={s.lbl} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }}>
            <div className="num">{s.num}</div>
            <div className="lbl">{s.lbl}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
export default Stats;
